/*
 * Copyright (C) America Móvil S.A.B de C.V - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Juan Manuel Garcia Junco Moreno <manue.garcia@ironbit.com.mx>, March 2020
 */
const { hasOwnProperty } = Object.prototype;

/**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */
function is(lhs: unknown, rhs: unknown): boolean {
    // SameValue algorithm
    if (lhs === rhs) {
        // Steps 1-5, 7-10
        // Steps 6.b-6.e: +0 != -0
        return lhs !== 0 || 1 / lhs === 1 / (rhs as 0);
    }
    // Step 6.a: NaN == NaN
    // eslint-disable-next-line no-self-compare
    return lhs !== lhs && rhs !== rhs;
}

/**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function shallowEqual(lhs: any, rhs: any): boolean {
    if (is(lhs, rhs)) {
        return true;
    }

    if (typeof lhs !== 'object' || lhs === null || typeof rhs !== 'object' || rhs === null) {
        return false;
    }

    const keysA = Object.keys(lhs);
    const keysB = Object.keys(rhs);

    if (keysA.length !== keysB.length) {
        return false;
    }

    // Test for A's keys different from B.
    for (let i = 0; i < keysA.length; i += 1) {
        if (!hasOwnProperty.call(rhs, keysA[i]) || !is(lhs[keysA[i]], rhs[keysA[i]])) {
            return false;
        }
    }

    return true;
}



// WEBPACK FOOTER //
// ./src/packages/core/lib/objects/shallowEqual.ts